export default "__VITE_ASSET__fd6504a7__"